module.exports = __webpack_public_path__ + "img/add-s.1341f8d4.svg";